/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import SmartsInterestingFieldRecommenderService from './SmartsInterestingFieldRecommenderService';
const _ = require('underscore');
const DEFAULT_LIMIT_INTETRESTING_FIELDS = 20;
class SmartsInterestingFieldRecommender {
	constructor(params) {
		this.dashboardApi = params.dashboardApi;

		this.logger = params.logger || {
			debug: function(){},
			error: function(){}
		};

		this.recommenderService = params.smartsInterestingFieldRecommenderService || new SmartsInterestingFieldRecommenderService({
			ajaxSvc: this.dashboardApi.getGlassCoreSvc('.Ajax'),
			logger: this.logger,
			requestName: 'SmartsInterestingFieldRecommender'
		});
	}

	_addCommonRequestParameters (requestParameters, options) {

		const module = options.module;

		const commonRequestParameters = {
			moduleId: module.getAssetId(),
			numResults: options.numResults || DEFAULT_LIMIT_INTETRESTING_FIELDS,
			sourceType: module.getSourceType(),
			shapedModule: (!!module.getShapingId()) //indicates that there is shaping
		};

		const tempSessionModuleJSON = module.getTemporarySessionModuleJSON();
		if( tempSessionModuleJSON ){
			commonRequestParameters.tempModule = JSON.stringify( tempSessionModuleJSON );
		}

		return module.saveTemporaryModule()
			.then((shapingModuleId) => {
				if (module.getAssetId() !== shapingModuleId) {
					commonRequestParameters.tempModuleId = shapingModuleId;
				}
				return _.extend({}, requestParameters, commonRequestParameters);
			});
	}

	recommendInterestingFields(options) {
		const requestParameters = {};

		return this._addCommonRequestParameters(requestParameters, options)
			.then((requestParameters) => this.recommenderService.recommendInterestingFields(requestParameters))
			.then((recommendedFields) => this._transformRecommendationListResponse(recommendedFields, options));
	}

	_transformRecommendationListResponse(recommendedFields,options) {
		return Promise.all(
			recommendedFields
				.map((field) => {
					return this._transformRecommendationResponse(field,options);
				})
		);
	}

	_transformRecommendationResponse(field,options) {
		const column = options.module.getMetadataColumn(field.fieldIDForExpression);
		return {
			name : column.getLabel(),
			id: column.getId()
		};
	}

}
export default SmartsInterestingFieldRecommender;



// WEBPACK FOOTER //
// ./src/js/util/SmartsInterestingFieldRecommender.js